import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationAr from "./locales/ar/translation.json";
import translationENG from "./locales/eng/translation.json";

const resources = {
	en: {
		translation: translationENG,
	},
	ar: {
		translation: translationAr,
	},
};

const language = localStorage.getItem("vr_lang");
if (!language || language === "undefined") {
	localStorage.setItem("vr_lang", "en");
}

i18n
	.use(detector)
	.use(initReactI18next)
	.init({
		resources,
		lng: localStorage.getItem("vr_lang") || "en",
		fallbackLng: "en",
		keySeparator: false,
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
